import axios from 'axios'
import { message } from 'ant-design-vue'
import router from '@/router'
import adminSession from '@/utils/adminSession'
import { normalizeDateTimes } from '@/utils/dateTime'
import { prepareRequestPayload } from '@/utils/requestPayload'

let isRedirectingLogin = false

function redirectToLogin() {
    if (isRedirectingLogin) return

    isRedirectingLogin = true
    message.error('登录过期，请重新登录')
    adminSession.clearAdminToken()

    if (router.currentRoute.path !== '/login') {
        router.replace({
            path: '/login',
            query: { redirect: router.currentRoute.fullPath }
        })
    }

    setTimeout(() => {
        isRedirectingLogin = false
    }, 1000)
}

// 创建 axios 实例
const service = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL || '/api',
    timeout: 6000
})

// 请求拦截器
service.interceptors.request.use(
    config => {
        if (['post', 'put', 'patch'].includes(String(config.method).toLowerCase())) {
            config.data = prepareRequestPayload(config.data)
        }
        const token = adminSession.getAdminToken()
        if (token) {
            config.headers['Authorization'] = 'Bearer ' + token
        }
        return config
    },
    error => Promise.reject(error)
)

// 响应拦截器
service.interceptors.response.use(
    response => {
        if (response.config.responseType === 'blob' || response.config.responseType === 'arraybuffer') {
            return response
        }
        const res = response.data
        // 约定 code 200 为成功
        if (res.code !== 200) {
            if (res.code === 401 || res.code === 403) {
                redirectToLogin()
                return Promise.reject(new Error(res.msg || '登录过期，请重新登录'))
            }
            message.error(res.msg || 'Error')
            return Promise.reject(new Error(res.msg || 'Error'))
        } else {
            return { ...res, data: normalizeDateTimes(res.data) }
        }
    },
    error => {
        const status = error.response && error.response.status
        if (status === 401 || status === 403) {
            redirectToLogin()
        } else {
            message.error(error.message)
        }
        return Promise.reject(error)
    }
)

export default service
